import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  const els = document.querySelectorAll('animation-underline, animation-border, .js-parallax-container, [data-tw-animation]')

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.setAttribute('data-in-viewport', 'true')
        entry.target.setAttribute('data-tw-has-animated', 'true')
      } else {
        entry.target.setAttribute('data-in-viewport', 'false')
      }
    }),
      {
        threshold: 1,
      }
  })

  els.forEach((el) => observer.observe(el))
})
